<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-row class="text-lightText">
          <div>
            I occasionally update this website. You can read my occasional
            <RouterLink to="/blog">blog posts</RouterLink>, check out my
            <RouterLink to="/projects">projects</RouterLink>, or read more
            <RouterLink to="/about"> about me</RouterLink>.
          </div>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
  <!-- <div>
    <div v-for="(card, index) in cards" :key="index">
      <v-slide-y-transition>
        <div
          v-if="card.show"
          class="flex flex-row items-center p-4 my-2 bg-white rounded shadow-md"
        >
          {{ card.message }}
        </div>
      </v-slide-y-transition>
    </div>
  </div> -->
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue"

const cards = ref([
  { message: "This is card 1", show: false },
  { message: "This is card 2", show: false },
  { message: "This is card 3", show: false }
])

onMounted(() => {
  // Stagger the animations
  cards.value.forEach((card, index) => {
    setTimeout(() => {
      card.show = true
    }, index * 150) // Adjust delay (500ms here) as needed
  })
})
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.my-2 {
  margin: 0.5rem 0;
}
</style>
